import AnaliticsMain from "./AnaliticsMain";
import React, {useEffect, useState} from "react";
import {get_cookie} from "../../helpers/get_cookie";
import {instance} from "../../API/API";

const AnaliticsGeneral = () => {
    const [objects, setObjects] = useState([]);
    const [works, setWorks] = useState([]);
    const [load, setLoad] = useState(false);
    const [objectData, setObjectData] = useState([]);
    const [finance, setFinance] = useState([]);
    const [filters, setFilters] = useState({start: 0, stop: 0, id: null});
    const [finance_filters, setFinanceFilters] = useState(null);

    useEffect(() => {
        const get_objects = async () => {
            setLoad(true);
            try {
                const get_objects_res = await instance.get(`objects/getObjects?avalible=1&api-key=null}`, {});
                if (get_objects_res) {
                    setObjects(get_objects_res.data.objects);
                }
            } catch (e) {
                console.error("Error fetching staff data:", e);
            } finally {
                setLoad(false);
            }
        };
        const get_works_data = async () => {
            setLoad(true);
            try {
                const hash = get_cookie("hash");
                if (!hash) {
                    console.error("API key not found in cookies");
                    return;
                }
                const get_works_data_res = await instance.get(`reports/get_works?api-key=${hash}`, {});

                if (get_works_data_res) {
                    setWorks(get_works_data_res.data.template);
                }
            } catch (e) {
                console.error("Error fetching staff data:", e);
            } finally {
                setLoad(false);
            }
        };
        get_objects();
        get_works_data()
    }, [])


    useEffect(() => {
        const get_object_data = async () => {
            setLoad(true);
            try {
                const get_object_data_res = await instance.get(
                    `analytics/get_analytics?
                    type=object&
                    id=${filters.id}&
                    start=${filters.start}&
                    stop=${filters.stop}&
                    api-key=null`, {}
                );

                if (get_object_data_res) {
                    setObjectData(get_object_data_res.data.data);
                }
            } catch (e) {
                console.error("Error fetching staff data:", e);
            } finally {
                setLoad(false);
            }
        };
        filters.id !== null && get_object_data()
    }, [filters])

    useEffect(() => {
        const get_finance_data = async () => {
            setLoad(true);
            try {
                const hash = get_cookie("hash");
                if (!hash) {
                    console.error("API key not found in cookies");
                    return;
                }
                const get_finance_data_res = await instance.get(
                    `analytics/get_analytics?
                    type=finance&
                    start=${finance_filters.start}&
                    stop=${finance_filters.stop}&
                    api-key=${hash}`, {});

                if (get_finance_data_res) {
                    setFinance(get_finance_data_res.data.data);
                }
            } catch (e) {
                console.error("Error fetching staff data:", e);
            } finally {
                setLoad(false);
            }
        };
        finance_filters && get_finance_data()
    }, [finance_filters])


    /*
        console.log(objects);
        console.log(objectData);
        console.log(finance);
        console.log(works);
    */


    return (
        <div>
            <AnaliticsMain
                objects={objects}
                data={objectData}
                loading={load}
                works={works}
                finance={finance}
                setFilters={setFilters}
                setFinanceFilters={setFinanceFilters}

            />
        </div>
    )


}


export default AnaliticsGeneral;


/*class AnaliticsGeneral extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.getObjectsThunkCreator();
        this.props.getWorksThunkCreator();
    }


    render() {
        return (
            <div>
                <AnaliticsMain
                    objects = {this.props.objects}
                    getData_1 = {this.props.getDataTable_1}
                    data = {this.props.data}
                    loading = {this.props.loading}
                    works = {this.props.works}
                    getData_3={this.props.getDataTable_3}
                    finance={this.props.finance}

                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        objects: state.analiticsRDCR.objects,
        data: state.analiticsRDCR.data,
        loading: state.analiticsRDCR.loading,
        works: state.analiticsRDCR.works,
        finance: state.analiticsRDCR.finance
    }
};

export default connect(mapStateToProps, {
    getObjectsThunkCreator,
    getDataTable_1,
    getWorksThunkCreator,
    getDataTable_3
})(AnaliticsGeneral);*/
